import { ReadoutState } from 'utils/recommendation-tiles-logic';

const BADGE_CLASS =
  'mr-1.5 inline-block rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide';

// The derived-type readout bar (AHA-6681 §B/§F): replaces the have dropdown
// as the composite-type display. Left-border color codes the state — green
// single hit, amber union, gray empty; equipment-backed states carry the
// lock badge, a fingerprint-matched legacy record shows its saved pick.
export default function ReadoutBar({ state }: { state: ReadoutState }) {
  let borderClass = 'border-l-gray-300';
  if (state.kind === 'single' || state.kind === 'legacy-saved-pick') {
    borderClass = 'border-l-green-600';
  } else if (state.kind === 'union') {
    borderClass = 'border-l-amber-500';
  }
  return (
    <div
      data-testid='readout-bar'
      className={`mt-2 rounded-r border-l-[3px] bg-white px-3 py-1.5 text-xs text-gray-600 ${borderClass}`}
    >
      {/* Amendment A/B copy: identifying the have unlocks tailored
          recommendations — want SELECTION below is never locked. */}
      {state.kind === 'empty' && (
        <>
          Tap the equipment you have — identifying your system type unlocks
          tailored recommendations. Or skip ahead and choose what you want
          below.
        </>
      )}
      {state.kind === 'legacy-saved-pick' && (
        <>
          Saved pick: <b className='text-gray-900'>{state.name}</b>
        </>
      )}
      {state.kind === 'single' && (
        <>
          {state.locked && (
            <span className={`${BADGE_CLASS} bg-slate-200 text-slate-700`}>
              🔒 From your equipment
            </span>
          )}
          Your system: <b className='text-gray-900'>{state.name}</b>
          {state.locked && <> — to change this, edit your equipment list.</>}
        </>
      )}
      {state.kind === 'union' &&
        (state.names.length === 0 ? (
          <>No matching system type for this combination.</>
        ) : (
          <>
            {state.locked && (
              <span className={`${BADGE_CLASS} bg-slate-200 text-slate-700`}>
                🔒 From your equipment
              </span>
            )}
            <span className={`${BADGE_CLASS} bg-amber-100 text-amber-800`}>
              Matches {state.names.length} types
            </span>
            Recommendations will cover all of:{' '}
            <b className='text-gray-900'>{state.names.join(' · ')}</b>
          </>
        ))}
    </div>
  );
}
